import { render, staticRenderFns } from "./vehicle.parameters.ai.vue?vue&type=template&id=3bdb8a4c&"
import script from "./vehicle.parameters.ai.vue?vue&type=script&lang=js&"
export * from "./vehicle.parameters.ai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports